import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconChevronRight = ({
  title = "Chevron right",
  color = "lightGray",
  viewBoxWidth = 8,
  viewBoxHeight = 12,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, color, ...otherProps }}>
    <g
      id="1440-Chevron-Right"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="New-About-us"
        transform="translate(-446.000000, -2796.000000)"
        fill={uiColorToBaseColor(color)}
      >
        <path
          d="M446.707107,2797.29289 L447.292893,2796.70711 C447.683418,2796.31658 448.316582,2796.31658 448.707107,2796.70711 L453.292893,2801.29289 C453.683418,2801.68342 453.683418,2802.31658 453.292893,2802.70711 L448.707107,2807.29289 C448.316582,2807.68342 447.683418,2807.68342 447.292893,2807.29289 L446.707107,2806.70711 C446.316582,2806.31658 446.316582,2805.68342 446.707107,2805.29289 L450,2802 L450,2802 L446.707107,2798.70711 C446.316582,2798.31658 446.316582,2797.68342 446.707107,2797.29289 Z"
          id="Rectangle-Chevron-Right"
        />
      </g>
    </g>
  </Svg.Icon>
)

export default IconChevronRight
